import { jsx as l, jsxs as i } from "react/jsx-runtime";
import { useReactTable as y, getGroupedRowModel as M, getCoreRowModel as N, getExpandedRowModel as S, flexRender as v } from "@tanstack/react-table";
import { Checkbox as C } from "../Checkbox/index.js";
import { Row as E } from "./Row/index.js";
import { AnimatePresence as $ } from "framer-motion";
import { typedForwardRef as k } from "../Select/tools.js";
import { useState as z, useEffect as G } from "react";
const I = k(
  (o, g) => {
    const {
      selectionRowMode: w,
      data: m,
      columns: c,
      groupBy: n,
      size: f = "regular",
      disabled: j,
      error: h = !1,
      initiallyExpandOnlyFirstRow: u,
      ...p
    } = o, [x, d] = z(!0), a = w === "multiple", r = f === "regular", s = y({
      data: m,
      columns: c,
      initialState: {
        expanded: !0,
        grouping: n && typeof n == "string" ? [n] : []
      },
      state: {
        expanded: x
      },
      enableGrouping: !0,
      onExpandedChange: (t) => {
        d(t);
      },
      getGroupedRowModel: M(),
      getCoreRowModel: N(),
      getExpandedRowModel: S()
    });
    G(() => {
      var t;
      if (u) {
        const e = (t = s.getRowModel().rows[0]) == null ? void 0 : t.id;
        if (!e)
          return;
        d({ [e]: !0 });
        return;
      }
      d(!0);
    }, [u]);
    const b = () => {
      if (!a)
        return;
      const { setSelectedRows: t, selectedRows: e } = o;
      if (e.length === m.length)
        return t([]);
      t(m);
    };
    return /* @__PURE__ */ l(
      "div",
      {
        ref: g,
        className: `jm-box-border jm-h-full jm-max-w-full jm-overflow-auto jm-border-solid jm-bg-white ${r ? "jm-rounded-2xl" : "jm-rounded-md"} ${j ? "jm-text-jutro-new-cool-gray-600" : "jm-text-jutro-new-cool-gray-800"} ${h ? "jm-border-2 jm-border-jutro-new-rose-600" : "jm-border jm-border-jutro-new-warm-gray-200"}`,
        children: /* @__PURE__ */ i(
          "table",
          {
            ...p,
            className: `jm-w-full jm-border-separate jm-border-spacing-0 ${r ? "jm-rounded-2xl" : "jm-rounded-md"} jm-bg-white`,
            children: [
              /* @__PURE__ */ i("thead", { className: "jm-sticky jm-left-0 jm-top-0 jm-z-1 jm-bg-jutro-new-warm-gray-50", children: [
                s.getHeaderGroups().map((t) => /* @__PURE__ */ l("tr", { children: t.headers.map((e) => /* @__PURE__ */ l(
                  "th",
                  {
                    colSpan: e.colSpan,
                    className: `jm-font-label jm-text-left ${r ? "jm-p-3" : "jm-p-2"}`,
                    children: /* @__PURE__ */ i("div", { className: "jm-flex jm-items-center", children: [
                      a && e.index === 0 && /* @__PURE__ */ l("div", { className: "-jm-mt-3", children: /* @__PURE__ */ l(
                        C,
                        {
                          name: e.id,
                          checked: o.selectedRows.length === m.length,
                          onChange: b,
                          disabled: j
                        }
                      ) }),
                      e.isPlaceholder ? null : /* @__PURE__ */ l("div", { className: "jm-flex jm-w-full jm-items-center", children: v(
                        e.column.columnDef.header,
                        e.getContext()
                      ) })
                    ] })
                  },
                  e.id
                )) }, t.id)),
                n && /* @__PURE__ */ l("tr", { className: "jm-h-1 jm-w-full", children: /* @__PURE__ */ l("th", { colSpan: c.length, className: "jm-bg-white" }) }),
                a && o.selectedRowsHeader && o.selectedRows.length > 0 && /* @__PURE__ */ l(
                  "div",
                  {
                    className: `jm-absolute jm-right-0 jm-top-0 jm-flex jm-h-[calc(100%-4px)] jm-items-center jm-bg-inherit ${r ? "jm-w-[calc(100%-58px) jm-h-[calc(100%-4px)]" : "jm-h-[calc(100%-2px)] jm-w-[calc(100%-50px)]"}`,
                    children: o.selectedRowsHeader
                  }
                )
              ] }),
              /* @__PURE__ */ l("tbody", { className: "jm-font-paragraph-1 jm-min-w-full", children: /* @__PURE__ */ l($, { initial: !1, children: s.getRowModel().rows.map((t, e, R) => /* @__PURE__ */ l(
                E,
                {
                  row: t,
                  index: e,
                  rows: R,
                  isRegularSize: r,
                  ...o
                },
                t.id
              )) }) })
            ]
          }
        )
      }
    );
  }
);
export {
  I as Table
};
//# sourceMappingURL=index.js.map
